import React, { useState, useEffect } from 'react';
import './menu.scss';
import { NavLink } from 'react-router-dom';
import { useLazyQuery, useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import DropdownOrganization from '../forms/dropdown/dropdown.organization';
import GraphQlClient from '../services/graphql';
import  {useTranslation} from "react-i18next";
import {PAGES} from "../services/interactions/audit.trail";

function AppMenu(props) {
    const { currentUser, toggleMenu, onLogout } = props;
    const [orgs, setOrgs] = useState([]);
    const [selectedOrg, setCurrentOrg] = useState(null);
    const { t} = useTranslation(['menu']);
    const [setMenuOrgs] = useLazyQuery(gqlSchemaLibrary.organizations.query.getAvailableOrgs, {
        onCompleted: (onOrgs) => {
            console.log('[Menu] getAvailableOrgs: ', onOrgs.getAvailableOrgs);
            if (onOrgs.getAvailableOrgs) {
                setOrgs(onOrgs.getAvailableOrgs);
                console.log('[MENU] currentUser: ', currentUser);
                const org = onOrgs.getAvailableOrgs.find(o => o._id === currentUser.selectedOrgId);
                setCurrentOrg(org);
            }
        }
    });

    const [changeToOrg] = useMutation(gqlSchemaLibrary.organizations.mutation.changeSelectedOrg, {
        onCompleted: ({changeSelectedOrg}) => {
            console.log('OK, Org changes: ', changeSelectedOrg);
            GraphQlClient.resetStore();
            const {selectedOrgId} = changeSelectedOrg;
            const org = orgs.find(o => o._id === selectedOrgId);
            setCurrentOrg(org);
        }
    })

    const changeOrg = (org) => {
        console.log('Changing to org: ', org);
        changeToOrg({
            variables: {
                toOrganizationId: org._id
            }
        })
    }

    useEffect(() => {
        if(!!currentUser){
            setMenuOrgs();
        }
    }, [currentUser, setMenuOrgs]);


    const currentOrg = () => {
        const org = selectedOrg;
        if(!org){
            return (<div className="orgSelect"><span></span><span></span></div>)
        } else {
            return (
                <DropdownOrganization options={orgs} value={selectedOrg} onChange={changeOrg} currentUser={currentUser} onLogout={onLogout} event={PAGES.PAGE_VIEW}/>
            )
        }
    }

    const showNavLink = (role) => {
        let showLink = false;
        if(role === 'userClinicians' || role === 'teams'){
            showLink = currentUser.userRoles.userClinicians.create;
        }
        return showLink;
    }

    return (
        <div id="AppMenu">
            <div className="hamburger" onClick={toggleMenu}>
                <i className="material-icons">
                    menu
                </i>
            </div>
            {currentOrg()}
            <div className="links">
                {
                   showNavLink("userClinicians") ?
                       <NavLink to="/users"
                                className={({ isActive, isPending }) => isPending ? "" : isActive ? "selected" : ""}>
                        <h2>{t('users')}</h2>
                    </NavLink> : ''
                }
                {
                   showNavLink("userClinicians") ?
                       <NavLink to="/teams"
                                className={({ isActive, isPending }) => isPending ? "" : isActive ? "selected" : ""}>
                        <h2>{t('teams')}</h2>
                    </NavLink> : ''
                }
                <NavLink to="/programs"
                         className={({ isActive, isPending }) => isPending ? "" : isActive ? "selected" : ""}>
                    <h2>{t('programs')}</h2>
                </NavLink>
                <NavLink to="/participants"
                         className={({ isActive, isPending }) => isPending ? "" : isActive ? "selected" : ""}>
                    <h2>{t('participants')}</h2>
                </NavLink>
                <NavLink to="/devices"
                         className={({ isActive, isPending }) => isPending ? "" : isActive ? "selected" : ""}>
                    <h2>{t('kits-and-devices')}</h2>
                </NavLink>
            </div>
        </div>
    )
}

export default AppMenu;
